import DOMPurify from "dompurify"

export const AsHtml = ({html}: {html: string}) => (
    <>
        { <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} /> }
    </>
)